<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <van-skeleton title :row="10" :loading="loadingPage">
      <div v-for="item in data.list" :key="item.cardTypeId" class="cardRect">
        <div v-if="item.sellTag" class="tag" :style="item.sellTagColor?'background-color:'+item.sellTagColor:'background-color:'+GetColorMainBack()"><span>{{ item.sellTag }}</span></div>
        <div class="lineTitle" @click="onSelect(item)">{{ item.name }}</div>
        <van-row>
          <van-col span="12" style="padding-left:13vw">
            <van-image
              :style="item.isSelect?'border-color: '+GetColorMainBack():''"
              class="img"
              width="35vw"
              :src="'/img/card'+item.frontJpgImage"
              @click="onSelect(item)"
            />
          </van-col>
          <van-col span="12" style="padding-right:13vw" class="rigth">
            <van-image
              :style="item.isSelect?'border-color: '+GetColorMainBack():''"
              class="img"
              width="35vw"
              :src="'/img/card'+item.backJpgImage"
              @click="onSelect(item)"
            />
          </van-col>
        </van-row>
        <div class="selectButton">
          <van-button plain round size="mini" style="padding:0 1.5em;" :loading="buttonLoading" hairline color="#ccc" @click="onConfirm(item)">选择卡面</van-button>
        </div>
      </div>
      <div class="emptyRect" />
      <div class="buttonRect">
        <van-button type="danger" size="large" :color="GetColorMain()" style="width:100%" :loading="buttonLoading" loading-text="保存中..." @click="onBuy">选择并购买实体卡</van-button>
      </div>
    </van-skeleton>
    <uploadUserHead v-model="showUploadHead" @change="onUploadHeadChange" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Image, Toast, Dialog, Skeleton } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import uploadUserHead from '@/components/uploadUserHead'
export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Skeleton.name]: Skeleton,
    TopBar,
    uploadUserHead
  },
  data() {
    return {
      titleTop: '',
      title: '卡面选择',
      backurl: '/store/index',
      id: undefined,
      buttonLoading: false,
      loadingPage: true,
      data: {
        list: [],
        isUserHaveIcon: true
      },
      showUploadHead: false
    }
  },

  created() {
    this.id = this.$route.params.id
    this.titleTop = GetSysTitle()
    this.init()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    init() {
      request({
        url: '/user/getUserCertificateFaceList',
        method: 'post',
        params: { id: this.id }
      }).then(response => {
        this.loadingPage = false
        if (!response.success) {
          return
        }
        this.data = response.data
        if (!this.data.isUserHaveIcon) {
          this.showUploadHead = true
        }
      })
    },
    onSelect(item) {
      if (this.buttonLoading) {
        return
      }
      this.data.list.forEach(el => {
        el.isSelect = false
      })
      item.isSelect = true
      this.data.list = JSON.parse(JSON.stringify(this.data.list))
    },
    onConfirm(item) {
      if (this.buttonLoading) {
        return
      }
      this.onSelect(item)
      this.saveSelect((url) => {
        if (!url) {
          window.history.length > 1
            ? this.$router.go(-1)
            : this.$router.push(this.backUrl)
        } else {
          Dialog.confirm({
            title: '选购实物卡片',
            message: '卡面选择成功!\n是否要前往选购实物卡片?',
            confirmButtonText: '购买卡片',
            confirmButtonColor: GetColorMainBack(),
            cancelButtonText: '返回列表'
          })
            .then(() => {
              this.$router.push(url)
            })
            .catch(() => {
              window.history.length > 1
                ? this.$router.go(-1)
                : this.$router.push(this.backUrl)
            })
        }
      })
    },
    onBuy() {
      this.saveSelect((url) => {
        if (url) {
          Toast.success('选择卡面成功!')
          this.$router.push(url)
        } else {
          Toast.fail('该卡面暂未开放购买,请稍后再试!')
          window.history.length > 1
            ? this.$router.go(-1)
            : this.$router.push(this.backUrl)
        }
      })
    },
    saveSelect(callback) {
      var selectItem = this.data.list.filter(item => item.isSelect === true)
      if (!selectItem || selectItem.length <= 0) {
        MyNotify('info', '必须选择一个卡面')
        return
      }
      if (!this.data.isUserHaveIcon) {
        this.showUploadHead = true
        MyNotify('info', '必须要上传证件照片才可以生成卡片')
        return
      }
      this.buttonLoading = true
      request({
        url: '/user/userCertificateFaceSelect',
        method: 'post',
        data: { userCertificateVirtualId: this.id,
          cardTypeId: selectItem[0].cardTypeId,
          justGetCommodityId: false
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        if (callback) {
          if (response.data) {
            var url = '/store/item/' + response.data.commodityId +
            '?SpecificationId=' + response.data.specificationId +
             '&certificateId=' + this.data.certificateId
            callback(url)
          } else {
            callback()
          }
        }
      })
    },
    onUploadHeadChange(data) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '上传照片中,请稍等'
      })
      request({
        url: '/User/updateUserHeadIcon',
        method: 'post',
        data: { data: data }
      }).then(response => {
        Toast.clear()
        if (!response.success) {
          return
        }
        this.data.isUserHaveIcon = true
        MyNotify('success', '照片上传成功')
      })
    }
  }
}
</script>
<style scoped>
.cardRect{
  background-color: #fff;
  margin-bottom: 0.5em;
  padding-bottom: 1em;
  position: relative;
  overflow: hidden;
}
.cardRect .tag{
  margin: 3vw;
  position: absolute;
  width: 60vw;
  height: 1.5em;
  line-height: 1.5em;
  left: -28vw;
  background-color: #fff;
  text-align: center;
  color: #fff;
  transform:rotate(-45deg);
  -webkit-transform:rotate(-45deg);
  -moz-transform:rotate(-45deg);
}
.cardRect .tag span{
  font-size: 0.7em;
}
.cardRect .lineTitle{
  padding: 1em 0;
  text-align: center;
  font-weight: 700;
}
.cardRect .selectButton{
  padding-top: 1em;
  text-align: center;
}
.cardRect .img{
  min-height:20vw;
  border-radius: 0.7em;
  overflow: hidden;
  border:2px solid #fff;
}
.emptyRect{
  height: 5.5em;
}
.buttonRect{
  padding: 1em;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  border-top: 1px solid #f5f5f5;
}
</style>
